import React from "react";
import { PageContainer } from "./Tasks.styled";
import { Paginator, Content } from "./components";

const Tasks = () => {
  const loading = false;
  const error = null;
  const tasks = [
    {
      id: 1,
      type: "Urgent",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 03/13/24",
    },
    {
      id: 2,
      type: "Quote Vehicle",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 03/13/24",
    },
    {
      id: 3,
      type: "Call Customer",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 05/13/24",
    },
    {
      id: 4,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Completed",
      timestamp: "7:30 AM · 05/13/24",
    },
    {
      id: 5,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Completed",
      timestamp: "7:30 AM · 01/13/25",
    },
    {
      id: 6,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 01/13/25",
    },
    {
      id: 7,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 03/13/25",
    },
    {
      id: 8,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 03/13/25",
    },
    {
      id: 9,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Pending",
      timestamp: "7:30 AM · 03/13/25",
    },
    {
      id: 10,
      type: "Send Mail",
      description: "Annual vehicle losds ds dsds d s ds ds ds ",
      category: "Marketing",
      status: "Completed",
      timestamp: "7:30 AM · 03/13/25",
    },
  ];
  const handleRefresh = () => {
    console.log("Refresh clicked");
  };

  return (
    <PageContainer>
      <Content loading={loading} error={error} tasks={tasks} onRefresh={handleRefresh} />
      <Paginator />
    </PageContainer>
  );
};

export default Tasks; 